import React from "react";
import ReactDOM from "react-dom";
import CarSelect from "../components/CarSelect";
import { SuburbModel } from "../models/SuburbModel";
import PostcodeInline from "../components/Postcode/PostcodeInline";
import each from "lodash/each";
import trim from "lodash/trim";
import BrochureDownloadPopup from "../components/BrochureDownload/BrochureDownloadPopup";
import BrochureEmailPopup from "../components/BrochureDownload/BrochureEmailPopup";

const BrochureDownload = (): void => {
  if (!document.querySelector(".brochureDownload")) {
    return;
  }

  const brochurePage = document.querySelector(".brochureDownload");
  if (brochurePage) {
    const popupWrapper = document.createElement("div");
    popupWrapper.setAttribute("class", "custom-download-overlay");
    brochurePage.appendChild(popupWrapper);
  }

  const views = {
    select: document.getElementById("select"),
    download: document.getElementById("download"),
    post: document.getElementById("post"),
    email: document.getElementById("email"),
    btns: document.querySelector(".brochureDownload__methods") as any,
    overlay: document.querySelector(".custom-download-overlay") as any,
  };

  const formFields = {
    models: document.querySelectorAll(".selectedModelNames"),
    images: document.querySelectorAll(".selectedModelImages"),
    postcode: document.querySelectorAll(".postcodeSelect"),
  };

  const recaptchaStatus = document.getElementById(
    "recaptchaStatus"
  ) as HTMLInputElement;

  const CS = new CarSelect(true, true);
  let location = {};
  let selectedCars = [];

  const shouldShowPostButton = (selectedCars) => {
    const downloadMessageOverrides = window["downloadMessageOverrides"];

    return selectedCars.every((selected) => {
      const carData = downloadMessageOverrides.find(
        (car) => car.modelPicker === selected.modelName
      );
      return carData ? carData.brochureAvailableViaPost : false;
    });
  };

  CS.onSelectionComplete = (cars) => {
    selectedCars = cars;
    const $brochureDownload_method_post = $(".btn[data-type='post']");

    if (shouldShowPostButton(selectedCars)) {
      $brochureDownload_method_post.show();
    } else {
      $brochureDownload_method_post.hide();
      views.post.style.display = "none";
    }

    if (selectedCars.length > 0) {
      views.btns.style.display = "flex";
      views.email.style.display = "block";
    }

    updateHiddenFields();
    updateLabels();
    if (document.querySelectorAll(".brochureDownload__post").length > 0) {
      if (
        document.querySelectorAll(".btn.active[data-type='post']").length > 0
      ) {
        updateMessage("post");
      }
    }
  };

  CS.onDeselectionComplete = (cars) => {
    selectedCars = cars;
    const $brochureDownload_method_post = $(".btn[data-type='post']");

    if (shouldShowPostButton(selectedCars)) {
      $brochureDownload_method_post.show();
    } else {
      $brochureDownload_method_post.hide();
    }

    if (selectedCars.length < 1) {
      views.btns.style.display = "none";
      views.email.style.display = "none";
      views.post.style.display = "none";

      each(views.btns.querySelectorAll("a"), (btn) => {
        btn.classList.remove("active");
      });
    }

    updateHiddenFields();
    updateLabels();
    if (document.querySelectorAll(".brochureDownload__post").length > 0) {
      if (
        document.querySelectorAll(".btn.active[data-type='post']").length > 0
      ) {
        updateMessage("post");
      }
    }
  };

  const updateHiddenFields = () => {
    const models = selectedCars.map((model) => model.modelName).join(",");
    const images = selectedCars.map((model) => model.modelName).join(",");
    each(formFields.models, (field) => (field.value = models));
    each(formFields.images, (field) => (field.value = images));
  };

  const updateLabels = () => {
    const contactMeBtn: any = document.querySelector(".formSplit__button");

    contactMeBtn.textContent = `I’d like my local dealer to contact me about ${
      selectedCars.length > 1 ? "these cars" : "this car"
    }`;

    const disclaimerOverrides = window["downloadMessageOverrides"];
    const modelSelectionDisclaimerEl = document.getElementById(
      "modelSelectionDisclaimer"
    );
    modelSelectionDisclaimerEl.innerText = "";
    disclaimerOverrides.forEach((overrideItem) => {
      if (
        selectedCars.find((x) => x.modelName === overrideItem.modelPicker) &&
        !!overrideItem.modelSelectionDisclaimer &&
        !modelSelectionDisclaimerEl.innerText
      ) {
        modelSelectionDisclaimerEl.innerText =
          overrideItem.modelSelectionDisclaimer;
      }
    });
  };

  const changeView = (view: string): void => {
    switch (view) {
      case "download":
        views.post.style.display = "none";
        views.select.style.display = "block";
        views.download.style.display = "none";
        views.overlay.style.display = "block";

        ReactDOM.render(
          <BrochureEmailPopup selectedCars={selectedCars} />,
          views.overlay
        );

        break;

      case "email":
        views.post.style.display = "none";
        views.email.style.display = "block";
        views.download.style.display = "none";
        views.overlay.style.display = "block";

        ReactDOM.render(
          <BrochureDownloadPopup
            selectedCars={selectedCars}
            isPupopFromEmail={true}
          />,
          views.overlay
        );
        break;

      case "post":
        views.email.style.display = "block";
        views.post.style.display = "block";
        views.download.style.display = "none";
        window["pushDigitalData"](
          {
            event: "_formNavigate",
            form: {
              name: `${view} a brochure`,
              stage: `${view} a brochure`,
            },
          },
          true
        );
        break;

      default:
        views.email.style.display = "none";
        views.post.style.display = "none";
        views.select.style.display = "block";
        views.download.style.display = "none";
        break;
    }
  };

  const validateField = (field, type = "text") => {
    if (!field) return true;

    const hasEvents = field.getAttribute("data-tracked") ? true : false;
    let isValid = true;

    function fail(field) {
      const msg = field.parentNode.querySelector("span");
      const label = field.parentNode.querySelector(".fieldLabel");
      const errorMessage = label
        ? `${label.textContent} is required`
        : `Please verify that you are not a robot`;

      field.classList.add("input-validation-error");
      field.classList.remove("valid");

      if (msg) {
        msg.classList.add("field-validation-error");
        msg.classList.remove("field-validation-valid");
        msg.textContent = errorMessage;
        if (type === "recaptcha") {
          msg.style.display = "block";
        }
      }

      isValid = false;
    }

    function pass(field) {
      const msg = field.parentNode.querySelector("span");

      field.classList.remove("input-validation-error");
      field.classList.add("valid");

      if (msg) {
        msg.classList.remove("field-validation-error");
        msg.classList.add("field-validation-valid");
        msg.textContent = ``;
        if (type === "recaptcha") {
          msg.style.display = "none";
        }
      }

      isValid = true;
    }

    switch (type) {
      case "phone":
        if (!RegExp(/^\d{10}$/).test(field.value)) {
          fail(field);
        } else {
          pass(field);
        }
        break;
      case "recaptcha":
        if (recaptchaStatus.value === "verified") {
          pass(field);
        } else {
          fail(field);
        }
        break;
      case "text":
      default:
        if (trim(field.value).length < 1) {
          fail(field);
        } else {
          pass(field);
        }
        break;
    }

    if (!hasEvents) {
      field.setAttribute("data-tracked", true);

      field.addEventListener("input", () => {
        validateField(field, type);
      });
    }

    return isValid;
  };

  const validatePostForm = (form: any) => {
    form.addEventListener("submit", async (e) => {
      let isValid: boolean = true;

      const textFields = ["first-name", "last-name", "StreetAddress"];
      textFields.forEach((f) => {
        const res = validateField(form.querySelector(`#${f}`));
        if (!res) isValid = false;
      });

      if (!validateField(form.querySelector(`#phone`), "phone")) {
        isValid = false;
      }

      if (!validateField(form.querySelector(`#recaptchaStatus`), "recaptcha")) {
        isValid = false;
      }

      const _userData = {
        emailHashed: await window["digestStringSHA256"](emailInput.value),
        phoneHashed: await window["digestStringSHA256"](
          form.querySelector(`#phone`).value
        ),
      };
      const _userFormData = await window["encryptUserData"]({
        encryptedEmail: emailInput.value,
        encryptedPhone: form.querySelector(`#phone`).value,
        encryptedFirstName: form.querySelector(`#first-name`).value,
        encryptedLastName: form.querySelector(`#last-name`).value,
      });

      const carNames = selectedCars.map((car) => car.modelName).join(", ");
      window["pushDigitalData"](
        {
          event: "_formNavigate",
          form: {
            name: "post a brochure",
            stage: "submitted",
            details: {
              dealerContact: contactCheckbox.checked,
              vehicleSelected: [
                {
                  make: "subaru",
                  model: carNames,
                },
              ],
            },
          },
          user: { ..._userData, ..._userFormData },
        },
        true
      );
      if (!isValid) {
        e.preventDefault();
      }
    });
  };

  const validateEmailForm = (form: any, enforceField) => {
    form.addEventListener("submit", async (e) => {
      let isValid: boolean = true;
      const textFields = ["first-name", "last-name"];
      const enforce = enforceField.checked;

      //Add noname to names
      textFields.forEach((f) => {
        const field = form.querySelector(`#${f}`);

        if (!enforce) {
          field.value = "noname";
        } else {
          if (field.value === "noname") {
            field.value = "";
          }
        }
      });

      if (enforce) {
        textFields.forEach((f) => {
          const res = validateField(form.querySelector(`#${f}`));
          if (!res) {
            isValid = false;
          }
        });

        if (!validateField(form.querySelector(`#phone`), "phone")) {
          isValid = false;
        }
      }
      const carNames = selectedCars.map((car) => car.modelName).join(", ");

      const _userData = {
        emailHashed: await window["digestStringSHA256"](emailInput.value),
        phoneHashed: await window["digestStringSHA256"](
          form.querySelector(`#phone`).value
        ),
      };
      const _userFormData = await window["encryptUserData"]({
        encryptedEmail: emailInput.value,
        encryptedPhone: form.querySelector(`#phone`).value,
        encryptedFirstName: form.querySelector(`#first-name`).value,
        encryptedLastName: form.querySelector(`#last-name`).value,
      });

      window["pushDigitalData"](
        {
          event: "_formNavigate",
          form: {
            name: "email a brochure",
            stage: "submitted",
            details: {
              dealerContact: contactCheckbox.checked,
              vehicleSelected: [
                {
                  make: "subaru",
                  model: carNames,
                },
              ],
            },
          },
          user: { ..._userData, ..._userFormData },
        },
        true
      );
      if (!isValid) {
        return e.preventDefault();
      }
    });
  };
  const disableFormInputs = (disable: boolean) => {
    const formInputs = document.querySelectorAll(".postBrochureDownload");
    if (disable == true) {
      each(formInputs, (_input) => {
        _input.setAttribute("disabled", "disabled");
      });
    } else {
      each(formInputs, (_input) => {
        _input.removeAttribute("disabled");
      });
    }
  };
  const updateMessage = (btn: string) => {
    const postMsg = document.getElementById("otherThanForesterMessage");
    const numCarSelected = document.querySelectorAll(
      ".carSelect__item--selected"
    ).length;
    const hasBRZSelected = document.querySelectorAll(
      '.carSelect__item--selected[data-modelname*="BRZ"]'
    ).length;
    const originalMsg =
      "Great! We just need a few extra details to get things rolling.";
    const containsBRZOthers =
      "Please note: We currently do not have full, printed brochures for the upcoming 2022 BRZ model. Please unselect in order to enable brochure post for any other models.";
    const onlyBRZ =
      "Please note: We currently do not have full, printed brochures for the upcoming 2022 BRZ model. Flyers for this model are available for download only.";

    if (btn === "post") {
      postMsg.innerHTML = originalMsg;
      postMsg.className = "";
      disableFormInputs(false);
    }
  };

  if (views.btns) {
    views.btns.style.display = "none";
    views.btns.addEventListener("click", (e) => {
      let btn = e.target;

      while (btn && btn.tagName !== "A") {
        btn = btn.parentNode;
      }

      if (btn === null || btn.tagName !== "A") return;

      e.preventDefault();

      each(views.btns.querySelectorAll("a"), (btn) => {
        btn.classList.remove("active");
      });

      btn.classList.add("active");
      changeView(btn.getAttribute("data-type"));
      updateMessage(btn.getAttribute("data-type"));
      window.sessionStorage.setItem(
        "BrochureDownloadMethod",
        btn.getAttribute("data-type")
      );
    });
  }

  //Set start
  changeView(null);

  //Load postcode field
  each(formFields.postcode, (wrap) => {
    let field = wrap.querySelector("input");
    let innerWrap = wrap.querySelector(".inlinePostcodeLookup");
    let form = wrap.parentNode;

    while (form && form.tagName !== "FORM") {
      form = form.tagName === "HTML" ? null : form.parentNode;
    }

    ReactDOM.render(
      <PostcodeInline
        emitEvents={true}
        fieldEl={field}
        formEl={form}
        simpleDisplay={true}
      />,
      innerWrap
    );
  });

  window.addEventListener("locationPreSelected", (e: any) => {
    const suburb: any = document.getElementById("Suburb");
    const state: any = document.getElementById("State");
    const location: SuburbModel = e.detail.suburb;

    if (suburb !== null) {
      suburb.value = location.name;
      suburb.classList.remove("input-validation-error");
    }

    if (state !== null) {
      state.value = location.state;
      state.classList.remove("input-validation-error");
    }
  });

  const contactCheckbox: any = document.getElementById("ContactMe");
  const postForm = document.querySelector(".brochureDownload__post form");
  const emailForm = document.querySelector(".brochureDownload__email form");

  const emailInput = document.querySelector(
    "#email.text"
  ) as HTMLInputElement | null;
  const emailBtn = document.querySelector("#tdSubmit");
  const postCodeField = document.querySelector("#post-code");
  const TermsChk = document.querySelector(
    '#terms[name="TocAgreement"]'
  ) as HTMLInputElement | null;

  if (emailInput && TermsChk) {
    let validEmail = false;
    let checkedTerms = false;
    emailInput.addEventListener("blur", () => {
      validEmail = !emailInput.classList.contains("input-validation-error");
      validateButton(validEmail, checkedTerms);
    });

    TermsChk.addEventListener("change", (e) => {
      const a = e.target as HTMLInputElement;
      checkedTerms = a.checked;
      validateButton(validEmail, checkedTerms);
    });
  }

  const validateButton = (validEmail: boolean, checkedTerms: boolean) => {
    if (validEmail && checkedTerms) {
      (emailBtn as HTMLInputElement).disabled = false;
      emailBtn.classList.remove("btn--disabled");
    } else {
      (emailBtn as HTMLInputElement).disabled = true;
      emailBtn.classList.add("btn--disabled");
    }
  };

  (window as any).onRecaptchaVerified = (token: string): void => {
    if (token) {
      recaptchaStatus.value = "verified";
    } else {
      recaptchaStatus.value = "";
    }
    if (postForm)
      validateField(postForm.querySelector(`#recaptchaStatus`), "recaptcha");
  };
  if (contactCheckbox && emailForm) {
    window.addEventListener("FormSplit", (e: any) => {
      contactCheckbox.checked = e.detail.state;
      emailForm.setAttribute("data-enforcepostcode", e.detail.state);

      const skipBtn = document.querySelector(
        ".brochureDownload__methods .btn[data-type='download']"
      ) as HTMLAnchorElement;
      if (!!skipBtn && contactCheckbox.checked) {
        skipBtn.classList.add("btn--disabled");
      } else {
        skipBtn.classList.remove("btn--disabled");
      }
    });
    if (postForm) validatePostForm(postForm);
  }

  if (emailForm) validateEmailForm(emailForm, contactCheckbox);

  $(document).ready(function () {
    $("#brochureForm").submit(function (event) {
      event.preventDefault(); // Prevent the default form postback

      var isValid: boolean = true;
      var formData = $(this).serialize();
      const enforce = contactCheckbox.checked;

      if (enforce) {
        const textFields = ["first-name", "last-name"];

        textFields.forEach((f) => {
          const res = validateField(document.querySelector(`#${f}`));
          if (!res) {
            isValid = false;
          }
        });
        if (isValid) {
          if (!validateField(document.querySelector(`#phone`), "phone")) {
            isValid = false;
          }
        }

        if (isValid) {
          isValid = postCodeField.classList.contains("pc__input--isValid");
        }
      }
      if (isValid) {
        $.ajax({
          type: "POST",
          url: "/umbraco/surface/brochuredownloadform/SubmitBrochureDownloadForm", // Update this URL if needed
          data: formData,
          success: function (response) {
            changeView("email");
            //clear text field values
            const textFields = ["first-name", "last-name"];
            textFields.forEach((f) => {
              const field = document.querySelector(`#${f}`) as HTMLInputElement ;
              field.value = "";
            });
          },
          error: function (xhr, status, error) {
            alert("Form submission failed: " + error);
          },
        });
      }
    });
  });
};
export default BrochureDownload;
